import React, { useState, useEffect } from "react";
import { Row } from "react-bootstrap";
import Layout from "template";
import { MenuItems } from "template/MenuItems";
import { NagarKhandaReportCard } from "./NagarKhandaRportsCard";
import { NagarSthayiReportCard } from "./NagarSthayiReportCard";
import { Link } from "react-router-dom";
import { APIService } from "services";
import {
  useParams
} from "react-router-dom";
import { useAppDispatch } from "redux/store";
import { setNagarType } from "redux/actions";

export const NagarKhandaReports: React.FC = () => {
  const [NagarCount, setNagarCount] = useState([])
  const [nagarSthayiCount, setNagarSthayiCount] = useState([])
  const dispatch = useAppDispatch();
  const { id } = useParams();
  let jillaId = localStorage.setItem("jilla_id", id)
  let vibhag_id = localStorage.getItem("vibhag_id")
  const [isLoading, setIsLoading] = React.useState(false);
  // console.log("20vibhag_id in nagarkhanda page",vibhag_id)
  useEffect(() => {
    // console.log("15id",type_id)
    setIsLoading(true)
    APIService.api().post("https://lhac.lokahitam.net/api/v1/samithi_members/searchWithFields", { type: "zilla", type_id: id }).then((response) => {
      console.log("22responsenagarkhandascreen", response)
      let vibhagData = response.data.SamithiReport
      let array = []
      array.push(response.data.SamithiReport[0])
      if (array && array.length > 0) {
        const filteredArray = array.filter(item => item !== undefined);
        setIsLoading(false)
        setNagarSthayiCount(filteredArray)
      }
      // console.log("24nagr_type",response.data.SamithiReport)
      const nagarTypes = vibhagData.map((item) => item.nagar_type);
      dispatch(setNagarType(nagarTypes));
      // console.log("23nagarTypes:", nagartype);
      setNagarCount(vibhagData)
    }).catch((err) => {
      console.log(err)
    })
  }, [1000]);
  let jilla_id = localStorage.getItem("jilla_id")
  // console.log("210nagar_khandaId",nagar_khandaId)
  // let vibhag_id=localStorage.getItem("vibhag_id")
  let upamandal_basthi_id = localStorage.getItem("upamandal_basthi_id")
  let MemberName = localStorage.getItem('member_name')
  let vibhagName = localStorage.getItem('vibhag_name')
  let jillaName = localStorage.getItem('zilla_name')
  let DesignationId = parseInt(localStorage.getItem("desig_level_id"))
  let nagarKhandaName = localStorage.getItem('nagar_khanda_name')
  let upMandalName = localStorage.getItem('upamandal_name')
  let gramamName = localStorage.getItem('gramam_name')
  // console.log("44upMandalNamegramamspage",upMandalName)
  let bastiName = localStorage.getItem('basti_name')
  let nagar_khandaId = localStorage.getItem('nagar_khanda_id')

  // console.log("44upbastiNamegramamspage",upMandalName)
  return (
    <Layout>
      <div className="container-fluid" >
        <div className="d-sm-flex align-items-center justify-content-between mb-4" >
          {/* <h1 className="h3 mb-0 text-gray-800" > Nagar/Khanda </h1> */}
        </div>
        <nav aria-label="breadcrumb">

          <ol className="breadcrumb" >


            {(DesignationId === 1 || DesignationId === 2) &&

              <li className="breadcrumb-item" ><Link to="/vibhagreports" style={{ color: "#194380" }}>{vibhagName}</Link></li>
            }
            {(DesignationId === 1 || DesignationId === 2 || DesignationId === 3) &&

              (vibhag_id != "undefined" && vibhag_id && vibhag_id != "null") &&
              <li className="breadcrumb-item" ><Link to={'/jillareports/' + vibhag_id} style={{ color: "#194380" }}>{jillaName}</Link></li>


            }
            {/* {(DesignationId===1 || DesignationId===2 || DesignationId===3|| DesignationId===4) && 
                            <li className="breadcrumb-item"><Link to={'/nagarkhandareports/'+jilla_id}  style={{color:"#194380"}}>{nagarKhandaName}</Link></li>
                            } */}

          </ol>
        </nav>
        <div className="h5 mb-0 font-weight-bold text-gray-800">
          <p>Namasthe ,{MemberName}  🙏</p></div>
        <div className="d-flex flex-column min-vh-100" >
          <Row>
            {nagarSthayiCount.map((item, i) => {
              return <NagarSthayiReportCard key={`Card-${i}`} id={item.id} nagar_type={item.nagar_type} total_basti_count={item.total_basti_count} total_gramas_count={item.total_gramas_count} total_gramas_formed={item.total_gramas_formed} total_samithi_formed={item.total_samithi_formed} nagar_khanda_name={item.nagar_khanda_name} gramas_formed={item.gramas_formed} samithi_formed={item.samithi_formed} total_basti={item.total_basti} total_gramas={item.total_gramas} />
            })}
          </Row>
          {isLoading ? (
            <div className="d-flex justify-content-center" style={{ marginTop: "230px" }}>
              <div className="spinner-border" role="status">
                <span className="visually-hidden"></span>
              </div>
            </div>
          ) :
            <Row>
              {NagarCount.map((item, i) => {
                return <NagarKhandaReportCard key={`Card-${i}`} id={item.id} nagar_type={item.nagar_type} nagar_khanda_name={item.nagar_khanda_name} gramas_formed={item.gramas_formed} samithi_formed={item.samithi_formed} total_basti={item.total_basti} total_gramas={item.total_gramas} />
              })}
            </Row>
          }
        </div>
      </div></Layout >
  );
};

